/**
 * Türkçe metin kataloğu — common, auth, profile, activation, rewards, errors, nav, inventory,
 * character, progression, activityFeed, oauth, app, admin, collection
 * Anahtarlar stabil API gibidir; metin değişse bile anahtar korunmalıdır.
 */

export const tr = {
  common: {
    brand: 'DEKOSTA',
    email: 'E-posta',
    password: 'Şifre',
    or: 'veya',
    orWithEmail: 'veya e-posta ile',
    privacyPolicy: 'Gizlilik Politikası',
    playerFallback: 'Oyuncu',
    adminPanel: 'Admin paneli',
    loading: '…',
    loadingPage: 'Yükleniyor...',
    emDash: '—',
    dashboard: {
      welcome: 'Hoş geldin, {name}',
      mainMetric: 'Ana metrik',
      collectionScoreLabel: 'Koleksiyon skoru',
      growHint: 'Koleksiyonunu büyütmenin en hızlı yolu: kod gir',
      clanUnlock300: '300 skorda takım katılımı açılır',
      clanUnlock1000: '1000 skorda takım kurma açılır',
      clanUnlocked1000: '1000 skorda takım kurma açıldı',
      loadError: 'Dashboard verileri yüklenemedi. Birazdan tekrar dene.',
      sectionScoreTitle: 'Koleksiyon Skoru',
      scoreFootnote: '{title}',
      scoreDescription: 'Gerçek dünyadan gelen koleksiyonun burada değer kazanır.',
      statCharacter: 'Karakter',
      breakdownCharacter: 'Karakter katkısı:',
      raritySection: 'Nadirlik dağılımı',
      scoreLabel: 'skor:',
      recentTitle: 'Son eklenenler',
      goCollection: 'Koleksiyona git',
      kindCharacter: 'Karakter',
    },
  },

  auth: {
    login: {
      title: 'Tekrar Hoş Geldin',
      subtitle: 'Koleksiyonuna devam et',
      toastEmailPasswordRequired: 'E-posta ve şifre gerekli.',
      toastWelcomeBack: 'Tekrar hoş geldin',
      loginFailedFallback: 'Giriş başarısız. Bilgilerini kontrol et.',
      placeholderEmail: 'eposta@adres.com',
      passwordDots: '••••••••',
      showPassword: 'Şifreyi göster',
      hidePassword: 'Şifreyi gizle',
      submitLoading: 'Devam ediliyor…',
      submit: 'Devam Et',
      secureNote: 'Güvenli giriş. Verilerin korunur.',
      googleContinue: 'Google ile devam et',
      forgotPassword: 'Şifremi unuttum',
      noAccount: 'Hesabın yok mu?',
      registerLink: 'Kayıt ol',
    },
    register: {
      title: 'Koleksiyonuna Başla',
      subtitle: 'Kodları topla, karakterleri aç',
      toastEmailRequired: 'E-posta gerekli.',
      toastPasswordMin: 'Şifre en az 8 karakter olmalı.',
      toastAccountReady: 'Hesabın hazır!',
      registerFailedFallback: 'Kayıt başarısız. Tekrar dene.',
      placeholderPassword: 'Şifreni gir',
      hintMinChars: 'En az 8 karakter',
      submitLoading: 'Başlanıyor…',
      submit: 'Başla',
      freeNote: 'Ücretsiz. Hemen başlayabilirsin.',
      hasAccount: 'Zaten hesabın var mı?',
      loginLink: 'Giriş yap',
      placeholderEmail: 'eposta@adres.com',
    },
    forgot: {
      subtitle: 'Şifre sıfırlama bağlantısı iste',
      toastSent: 'Kayıtlı adrese sıfırlama bağlantısı gönderildi.',
      requestFailedFallback: 'İstek gönderilemedi. Tekrar dene.',
      submitLoading: 'Gönderiliyor...',
      submit: 'Sıfırlama Bağlantısı Gönder',
      backToLogin: 'Girişe dön',
    },
    reset: {
      subtitle: 'Yeni şifreni belirle',
      labelNew: 'Yeni Şifre',
      labelNewAgain: 'Yeni Şifre (Tekrar)',
      toastInvalidLink: 'Geçersiz sıfırlama bağlantısı.',
      toastPasswordMin: 'Şifre en az 8 karakter olmalı.',
      toastMismatch: 'Şifreler eşleşmiyor.',
      toastUpdated: 'Şifren güncellendi. Giriş yapabilirsin.',
      resetFailedFallback: 'Şifre sıfırlanamadı.',
      submitLoading: 'Güncelleniyor...',
      submit: 'Şifreyi Güncelle',
      successBanner: 'Şifre güncellendi.',
      goToLogin: 'Giriş sayfasına git',
      invalidLinkFallback: 'Geçersiz sıfırlama bağlantısı.',
      expiredFallback: 'Sıfırlama bağlantısının süresi dolmuş olabilir.',
      noToken: 'Bağlantıda token bulunamadı.',
      backToLogin: 'Girişe dön',
    },
    unexpectedResponse: 'Sunucu beklenmeyen yanıt döndü. Tekrar dene.',
    sessionVerifyFailed:
      'Oturum doğrulanamadı. Ağ bağlantını kontrol et veya tekrar giriş yap.',
    sessionExpired: 'Oturum süren doldu, tekrar giriş yap.',
    userNotFound:
      'Hesabınız bulunamadı, lütfen tekrar giriş yapın veya destekle iletişime geçin.',
    callback: {
      cancelled: 'Giriş iptal edildi',
      sessionInvalid: 'Oturum doğrulanamadı. Tekrar giriş yap.',
      loginOk: 'Giriş tamam.',
      sessionNotFound: 'Oturum bulunamadı',
      completing: 'Giriş tamamlanıyor…',
      nativeFallback:
        'Uygulama otomatik açılmadıysa aşağıdan tekrar deneyin veya girişe dönün.',
      openApp: 'Uygulamaya dön',
      goLogin: 'Giriş sayfasına git',
    },
  },

  profile: {
    title: 'Profil',
    navAppearance: 'Görünüm',
    navAchievements: 'Başarımlar',
    navFriends: 'Arkadaşlar',
    navAccount: 'Hesap ayarları',
    sectionProfile: 'Profil',
    sectionCollection: 'Koleksiyon',
    toastEmailVerified: 'E-posta adresin doğrulandı.',
    toastLinkInvalid: 'Bağlantı geçersiz veya süresi dolmuş.',
    toastAlreadyVerified: 'E-postan zaten doğrulanmış.',
    toastVerificationSent: 'Doğrulama e-postası gönderildi.',
    sendFailedFallback: 'Gönderilemedi. Biraz sonra tekrar dene.',
    toastEmailRequired: 'E-posta adresi gerekli.',
    toastEmailUpdated: 'E-posta güncellendi. Yeni bir doğrulama maili gönderildi.',
    emailUpdateFailedFallback: 'E-posta güncellenemedi.',
    verifyBannerTitle: 'E-postanı doğrula',
    verifyBannerBody:
      'Fiziksel kutu ve kart aktivasyon kodunu girebilmek için e-postanı doğrulaman gerekir. Gelen kutunu ve spam klasörünü kontrol et; mail gelmediyse aşağıdan tekrar gönderebilirsin.',
    resendLoading: 'Gönderiliyor…',
    resend: 'Doğrulama maili gönder',
    editEmail: 'E-postayı düzelt',
    newEmailLabel: 'Yeni e-posta',
    saveLoading: 'Kaydediliyor…',
    saveAndSend: 'Kaydet ve mail gönder',
    statsCharacter: 'Karakter',
    statsCredit: 'Kredi',
    collectionScoreHeading: 'Koleksiyon Skoru',
    accountWide: 'Hesap geneli',
    adminHeading: 'Yönetim paneli',
    adminDesc: 'Yönetici araçlarına geçiş yap',
    footerBrand: 'DEKOSTA',
  },

  friends: {
    pageTitle: 'Arkadaşlar',
    addSection: 'Kullanıcı adı ile ekle',
    addHint:
      'Arkadaşının profilde görünen kullanıcı adını gir (@ işareti isteğe bağlı). E-posta ile arama yapılmaz.',
    usernamePlaceholder: 'ornek_kullanici',
    sendRequest: 'İstek gönder',
    sending: 'Gönderiliyor…',
    requestSent: 'Arkadaşlık isteği gönderildi.',
    incomingSection: 'Gelen istekler',
    incomingEmpty: 'Bekleyen istek yok.',
    outgoingSection: 'Giden istekler',
    outgoingEmpty: 'Gönderilmiş bekleyen istek yok.',
    listSection: 'Arkadaşların',
    listEmpty: 'Henüz arkadaşın yok. Yukarıdan kullanıcı adı ile istek gönderebilirsin.',
    accept: 'Kabul',
    decline: 'Reddet',
    cancelRequest: 'İptal et',
    remove: 'Çıkar',
    accepted: 'Arkadaşlık kuruldu.',
    declined: 'İstek reddedildi.',
    cancelled: 'İstek iptal edildi.',
    removed: 'Arkadaş listeden çıkarıldı.',
    usernameRequired: 'Kullanıcı adı gir.',
    loadError: 'Arkadaş listesi yüklenemedi.',
    sendFailed: 'İstek gönderilemedi.',
    actionFailed: 'İşlem tamamlanamadı.',
  },

  activation: {
    pageTitle: 'Aktivasyon kodu',
    heroTitle: 'Aktivasyon Kodu',
    heroSubtitle: 'Kutundan çıkan kodu gir, koleksiyonunu büyüt',
    enterCode: 'Kod Gir',
    formTitle: 'Kutudaki kodu girin',
    formLineBeforeStrong: 'Fiziksel kutundaki',
    formStrong: 'aktivasyon kodunu',
    formLineAfterStrong: 'yaz.',
    formOptionalNote: 'DEK ön eki isteğe bağlıdır.',
    formHint: 'Kodu onayladığında ödülün koleksiyonuna işlenir; karakterde yıldız / destek ve takım adımı net gösterilir.',
    labelCode: 'Kod',
    codePlaceholder: 'DEK-7M4P-2XQ9-L8AF',
    toastCodeLength: '12 karakterlik kodu gir.',
    emailNotVerified:
      'Kutu veya kart kodunu kullanmak için önce e-postanı doğrula. Profil sayfasından devam edebilirsin.',
    unknownSeries: 'Bilinmeyen Seri',
    microcopy: {
      ocrAccepted: 'Kod algılandı. Kontrol edip aktive et.',
      ready: 'Kod hazır',
      processing: 'Kod işleniyor…',
      preparingReward: 'Ödül hazırlanıyor…',
    },
    quickGuide: {
      dismissAria: 'Rehberi kapat',
      stepEnterCode: 'Kodunu gir',
      stepEarn: 'Karakter kazan',
      stepGrow: 'Koleksiyonunu büyüt ve sıralamada yüksel',
    },
    emptyCollection: {
      title: 'Koleksiyonunu başlat',
      hint: 'Yukarıdan kod girerek başla',
    },
  },

  rewards: {
    reveal: {
      youWon: 'Kazandın!',
      preparingIntro: 'Hazırlanıyor…',
      mythicChar: 'Mitik bir güç koleksiyonuna katıldı',
      legendaryChar: 'Efsanevi bir keşif!',
      epicChar: 'Güçlü bir güç koleksiyonuna katıldı',
      rareChar: 'Nadir bir keşif!',
      uncommonChar: 'Koleksiyonuna sağlam bir parça eklendi',
      defaultChar: 'Yeni bir parça kazandın!',
      ownership: '{name} artık koleksiyonunda.',
      motivationChar:
        'İlk nüsha karakterini koleksiyona ekler; aynı karakterden sonraki nüshalar yıldız ve destek bonusunu büyütür.',
      motivationCharDup:
        'Bu karakterden yeni bir nüsha: yıldız ve destek hesabın güncellendi, koleksiyon skorun arttı.',
      motivationCharStarUp:
        'Yıldız seviyen yükseldi; destek bonusun ve skorun bu nüshaya göre yenilendi.',
      chipAddedChar: 'Yeni karakter nüshası',
      chipCharDup: 'Ek nüsha — yıldız & destek',
      chipScore: 'Koleksiyon skoru güncellendi',
      chipStack: 'Yıldız & destek kaydı güncellendi',
      chipStackDup: 'Destek nüshası & skor güncellendi',
      chipStarUp: 'Yıldız seviyesi arttı',
      chipRarityUncommon: '{rarity} — belirgin skor katkısı',
      chipRarityHigh: '{rarity} — güçlü skor katkısı',
      detailsTitleDefault: 'Ödülün hazır',
      detailsTitleCharFirst: 'Yeni karakter kazandın',
      detailsTitleCharDup: 'Karakter nüshan güçlendi',
      detailsTitleCharStarUp: 'Yıldızın yükseldi',
      collectionSubCharDup: 'Ek nüsha ile destek bonusu ve yıldız hesabın güncellendi.',
      collectionSubCharStar: 'Yeni yıldız eşiği — destek ve skor buna göre yenilendi.',
      footerDefault: 'Koleksiyonunu büyütmeye devam et.',
      footerChar: 'Yeni kodlarla karakter yıldızını ve koleksiyonunu güçlendirebilirsin.',
      ctaContinue: 'Devam et',
      ctaTryAgainRare: 'Bir tane daha dene',
      ctaNewCode: 'Yeni kod kullan',
      detailDefault: 'Detayı incele',
      detailCharacter: 'Karakter detayını incele',
    },
  },

  errors: {
    http: {
      status400: 'İstek tamamlanamadı. Bilgileri kontrol edip tekrar dene.',
      status401: 'Oturumun süresi dolmuş olabilir. Tekrar giriş yap.',
      status403: 'Bu işlem için yetkin yok.',
      status404: 'Aradığın kayıt bulunamadı veya artık sende değil.',
      status409: 'İşlem çakıştı. Bir saniye sonra tekrar dene.',
      status429: 'Çok hızlı istek. Kısa süre sonra tekrar dene.',
      status503: 'Sunucu yoğun veya kod işleniyor. Birkaç saniye sonra tekrar dene.',
      status500: 'Beklenmeyen bir hata. Biraz sonra tekrar dene.',
    },
    processingRetry: 'Kod veya işlem hâlâ tamamlanıyor olabilir. Birkaç saniye sonra tekrar dene.',
    releaseNotInInventory: 'Bu öğe envanterinde yok. Sayfayı yenileyip tekrar dene.',
    activateCodeIncomplete: 'Kod eksik görünüyor. Karttaki 12 karakteri kontrol et.',
    activateInvalidChar: 'Kodda kullanılamayan bir karakter var. Sadece karttaki harf ve rakamları kullan.',
    activateCodeRequired: 'Kodu girmen gerekiyor.',
    activateResponseInvalid: 'Yanıt okunamadı. Tekrar dene.',
    activateSuccessCharacterFirst: 'Karakter koleksiyonuna eklendi.',
    activateSuccessCharacterDup: 'Ek karakter nüshası eklendi.',
    activateSuccessCharacterStarUp: 'Yıldız seviyen yükseldi.',
    activateAlreadyOwned:
      'Bu kod zaten koleksiyonunda. Her şey yolunda — ekstra bir şey yapmana gerek yok.',
    activateAlreadyUsed: 'Bu kod başka bir koleksiyoncu tarafından kullanılmış. Farklı bir kod dene.',
    activateDisabled: 'Bu kod devre dışı. Yardım için destek veya satıcıyla iletişime geçebilirsin.',
    activateNotFound: 'Bu kodu tanıyamadık. Yazımı kontrol et veya karttaki kodla karşılaştır.',
    activateBusy: 'Kod şu an başka bir işlemde. Birkaç saniye sonra tekrar dene.',
    activateInvalidStatus: 'Bu kod şu anda kullanılamıyor. Daha sonra tekrar dene.',
    activateWrongType: 'Bu kod türü burada kullanılamıyor. Farklı bir aktivasyon yöntemi dene.',
    activateRewardMissing:
      'Kod geçerli görünüyor ama ödül bulunamadı. Destek ekibine bildirebilirsin.',
    activateInvalidFormat: 'Kod formatı uygun değil. Karttaki DEK kodunu kontrol et.',
    activateGenericInvalid: 'Bu kod kullanılamıyor.',
    activateDoneGeneric: 'İşlem tamamlandı.',
    characterFetchFailed:
      'Karakter bilgisi yüklenemedi. İnternet bağlantını kontrol edip tekrar dene.',
    redeemResponseInvalid: 'Yanıt okunamadı.',
    redeemUnavailable:
      'Bu kod kullanılamıyor veya başkası tarafından alınmış olabilir.',
    redeemRewardReady: 'Ödülün hazır — koleksiyonuna eklendi.',
    redeemUsed: 'Kod kullanıldı.',
    releaseWithName: '{name} koleksiyonundan çıkarıldı.',
    releaseGeneric: 'Öğe koleksiyonundan çıkarıldı.',
    releaseCodeFreed: 'Kart kodun tekrar kullanıma açıldı: {code}',
    releaseCodeMaybe: 'Kart kodun uygunsa yeniden talep edilebilir.',
    releaseDupWithCode: 'Bu işlem zaten tamamlanmış. Kodun serbest: {code}',
    releaseDupNoCode: 'Bu öğe zaten koleksiyonundan çıkarılmış. Her şey güncel.',
  },

  collection: {
    itemGroup: {
      multiCopySectionTitle: 'Çoklu örnek · koleksiyon katkısı',
      scoreDupLineLabel: 'Çoklu örnek katkısı',
      statFoot:
        '{count} örnek — skor taban ve çoklu örnek oranından oluşur; takılı kullanım ek katkı sağlar.',
      scrollHintItem: 'Kaydır — örnekler ve aksiyonlar',
      detailScreenHint: 'Detayda slot, takılma ve örnekleri yönet',
    },
  },

  nav: {
    home: 'Ana sayfa',
    code: 'Kod',
    collection: 'Koleksiyon',
    leaderboard: 'Sıralama',
    profile: 'Profil',
    ariaMain: 'Ana navigasyon',
  },

  inventory: {
    loadFailedTitle: 'Envanter yüklenemedi',
    retry: 'Tekrar dene',
  },

  app: {
    accountPreparing: 'Hesap hazırlanıyor...',
  },

  oauth: {
    bridgeSuccess: 'Giriş başarılı',
    bridgeSessionInvalid: 'Oturum doğrulanamadı',
    redirectBaseMissing:
      'Google girişi: yönlendirme adresi yok. Telefonda localhost kullanıyorsanız frontend/.env içine REACT_APP_FRONTEND_PUBLIC_URL ekleyip npm run build ve npx cap sync android yapın.',
    invalidPublicUrl: 'REACT_APP_FRONTEND_PUBLIC_URL geçerli bir https:// adresi olmalıdır.',
    localhostOAuth:
      'OAuth dönüşü hâlâ localhost. Uygulamayı güncel kodla yeniden derleyin: npm run build → npx cap sync android → APK kurulumu.',
  },

  character: {
    codeToggleShorten: 'Kısalt',
    codeToggleFull: 'Tam kod',
    starsSection: 'Yıldız',
    starAriaLabel: 'Yıldız {stars}',
    copyProgressLabel: 'Kopya ilerlemesi',
    infoSection: 'Bilgi',
  },

  profileAccount: {
    emailLabel: 'E-posta',
    statusLabel: 'Durum',
    usernameHeading: 'Kullanıcı adı',
    usernameChangeOnce: 'Kullanıcı adı yalnızca bir kez değiştirilebilir.',
    usernameEmpty: 'Kullanıcı adı boş olamaz.',
    usernameUpdated: 'Kullanıcı adı güncellendi.',
    usernamePlaceholder: 'ornek_kullanici',
  },

  profileAvatar: {
    updated: 'Profil avatarın güncellendi.',
    selectFailed: 'Avatar seçilemedi.',
    tierStart: 'Başlangıç',
    tierSpecial: 'Özel koşul kilidi',
    tierFragment: 'Parça kilidi',
  },

  profileAchievements: {
    unlocked: 'Açıldı',
  },

  progression: {
    maxStarCharacter: 'Bu karakter şu anda maksimum gelişimde.',
    remainingOne: 'Sonraki yıldıza çok yaklaştın — sadece 1 {unit} kaldı.',
    remainingTwo: 'Bir adım daha — iki {unit} sonraki yıldız eşiğine yaklaştırır.',
    nearNextStar: 'Sonraki yıldıza oldukça yakınsın.',
    supportBonusOn:
      'Destek nüshalar karakterini güçlendirir; daha fazla nüsha daha yüksek bonus sağlar.',
    supportBonusOff: 'Yeni nüshalar bu karakteri ve koleksiyon skorunu güçlendirebilir.',
    cardHintOne: 'Yıldıza 1 {unit} kaldı — kod ile devam et',
    cardHintTwo: 'Yıldıza yakınsın — kod ile güçlendir ({unit})',
    unitCopy: 'nüsha',
  },

  activityFeed: {
    templates: {
      rareDrop: '{user} {character} ({rarity}) ile nadir bir keşif yaptı',
      scoreMilestone: '{user} koleksiyon skorunu {score} seviyesine ulaştırdı',
      starProgress: '{user} {character} karakterini {star_level}★ seviyesine çıkardı',
      activationCharacter: '{user} yeni bir karakter kazandı: {asset}',
      achievementUnlocked: '{user} başarı kazandı: {achievement}',
    },
    fallbackGeneric: 'Koleksiyonda yeni bir gelişme',
    collectorDefault: 'Bir koleksiyoncu',
    fallbackDefault: '{user} koleksiyonunda yeni bir gelişme oldu',
  },

  collectionUi: {
    profileSkeletonLoading: 'Profil verileri yükleniyor…',
  },

  admin: {
    operationFailed: 'İşlem başarısız',
    loadFailed: 'Veri yüklenemedi',
    sessionInvalid: 'Oturum geçersiz. Tekrar giriş yapın.',
    requestTimeout: 'İstek zaman aşımı. Tekrar deneyin.',
    copied: 'Kopyalandı',
    csvDownloaded: 'CSV indirildi',
    saveFailed: 'Kayıt başarısız',
    deleteFailed: 'Silme başarısız',
    positiveInteger: 'Pozitif tam sayı girin',
    usersLoadFailed: 'Kullanıcılar yüklenemedi',
    userStatsLoadFailed: 'Kullanıcı istatistikleri yüklenemedi',
    inventoryLoadFailed: 'Envanter yüklenemedi',
    boxes: {
      listLoadFailed: 'Kutu listesi yüklenemedi',
      charItemListFailed: 'Karakter listesi yüklenemedi',
      created: 'Kutu başarıyla oluşturuldu',
      bulkDone: 'Toplu üretim tamamlandı',
      distributeDone: 'Dağıtım tamamlandı',
      distributeFailed: 'Dağıtım başarısız',
      exportStarted: 'Export başlatıldı',
      exportFailed: 'Export başarısız',
    },
    series: {
      loadFailed: 'Seriler yüklenemedi',
      updated: 'Seri güncellendi',
      created: 'Seri oluşturuldu',
      disabled: 'Seri devre dışı bırakıldı',
    },
    activityFeed: {
      settingsReadFailed: 'Ayarlar okunamadı',
      settingsSaved: 'Aktivite feed ayarları kaydedildi',
    },
    cardTemplates: {
      listLoadFailed: 'Şablonlar yüklenemedi',
      readFailed: 'Şablon okunamadı',
      created: 'Şablon oluşturuldu',
      saved: 'Kaydedildi',
      duplicateCreated: 'Kopya oluşturuldu',
      deactivated: 'Pasif yapıldı',
      imageUploaded: 'Görsel yüklendi',
      invalidJsonFields: 'Geçersiz JSON: fields dizisi gerekli',
      fieldsImported: 'Alanlar içe aktarıldı (kaydetmeyi unutmayın)',
      jsonReadFailed: 'JSON okunamadı',
      previewNotReady: 'Önizleme alanı hazır değil',
      pngFailed: 'PNG oluşturulamadı',
      typoCopied: 'Tipografi panoya kopyalandı',
      typoPasted: 'Tipografi yapıştırıldı',
      createFailed: 'Oluşturulamadı',
      duplicateFailed: 'Kopyalanamadı',
      uploadFailed: 'Yükleme başarısız',
    },
    items: {
      dataLoadFailed: 'Veriler yüklenemedi',
      imageUploaded: 'Görsel yüklendi',
      imageUploadFailed: 'Görsel yüklenemedi',
      nameRequired: 'Ad zorunlu',
      selectCollection: 'Koleksiyon / seri seçin',
      orderMin: 'Koleksiyon sıra no en az 1 olmalı',
      partsMin: 'Toplam parça sayısı en az 1 olmalı',
      entityCreatedNoId: 'Varlık oluşturuldu ancak kimlik alınamadı',
      digitalMetaFailedCreate: 'Varlık oluşturuldu, ancak dijital meta kaydedilemedi.',
      digitalMetaFailedUpdate: 'Kart güncellendi, ancak dijital meta kaydedilemedi.',
      cardSaved: 'Kart ve sistem alanları kaydedildi',
      createdWithCard: 'Oluşturuldu; kart ve sistem alanları kaydedildi',
      characterDeactivated: 'Karakter pasifleştirildi',
    },
    activationCodes: {
      charItemListFailed: 'Karakter listesi yüklenemedi',
      selectLinked: 'Bağlı öğe seçin',
      codesGenerated: '{count} aktivasyon kodu üretildi',
      generateFailed: 'Kod üretimi başarısız',
      disabled: 'Aktivasyon kodu devre dışı bırakıldı',
      reenabled: 'Aktivasyon kodu tekrar kullanılabilir',
    },
    settings: {
      listLoadFailed: 'Ayarlar listesi yüklenemedi',
      selectDataset: 'En az bir veri kümesi seçin',
      enterPassword: 'Hesap şifrenizi girin',
      confirmPhrase: 'Onay metni tam olarak "{phrase}" olmalıdır',
      resetDone: 'Sıfırlama tamamlandı',
      importFailed: 'İçe aktarma başarısız',
    },
    digitalMeta: {
      loadFailed: 'Dijital meta yüklenemedi',
      saved: 'Dijital meta kaydedildi',
    },
    audit: {
      loadFailed: 'Audit logları yüklenemedi',
    },
    missions: {
      listLoadFailed: 'Görev listesi yüklenemedi',
      selectAvatar: 'Parça hedefi avatar seçin',
      updated: 'Görev güncellendi',
      created: 'Görev oluşturuldu ({id})',
    },
    progression: {
      loadFailed: 'Progression ayarları yüklenemedi',
      saved: 'Progression ayarları kaydedildi',
      saveFailed: 'Kaydetme başarısız',
    },
    avatars: {
      listLoadFailed: 'Avatar listesi yüklenemedi',
      imageUploaded: 'Görsel yüklendi — kadrajı ayarlayabilirsiniz',
      imageFailed: 'Görsel yüklenemedi',
      imageUrlRequired: 'Görsel URL gerekli: dosya yükleyin veya image_url girin',
      updated: 'Avatar güncellendi',
      created: 'Avatar oluşturuldu',
      deactivated: 'Pasifleştirildi',
      activated: 'Aktifleştirildi',
      statusFailed: 'Durum güncellenemedi',
    },
  },
};
